import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { ClosingScheduleStore } from "../store/closingScheduleStore";

export const useClosingScheduleStore = () =>
  useContext<{ closingScheduleStore: ClosingScheduleStore; }>(StoreContext);
